export default "__VITE_ASSET__Cl5f_sA9__"